import { render, staticRenderFns } from "./DetailResultDudi.vue?vue&type=template&id=1d156391&scoped=true&"
import script from "./DetailResultDudi.vue?vue&type=script&lang=js&"
export * from "./DetailResultDudi.vue?vue&type=script&lang=js&"
import style0 from "./DetailResultDudi.vue?vue&type=style&index=0&id=1d156391&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d156391",
  null
  
)

export default component.exports